import React from 'react';
const md5 = require('md5');

interface AulaCardProps {
  instructor: string;
  day: string;
  url?: string;
  instagram?: string;
}

export const AulaCard: React.FC<AulaCardProps> = ({ instructor, day, url, instagram }) => {
  const handleClick = () => {
    if (url && url.trim()) {
      window.open(url, '_blank');
    }
  };

  return (
    <div
      className={`p-5 bg-card rounded-lg border flex items-center gap-4 ${url && url.trim() ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
      onClick={handleClick}
    >
      {instagram && instagram.trim() && (
        <img
          src={`https://www.gravatar.com/avatar/${md5(instagram.trim().toLowerCase())}`}
          alt={`Avatar de ${instructor}`}
          width={48}
          height={48}
          className="rounded-full flex-shrink-0"
        />
      )}
      <div>
        <h3 className="text-base font-semibold text-primary mb-0.5">{instructor}</h3>
        <p className="text-sm text-muted-foreground">{day}</p>
        {url && url.trim() && (
          <p className="text-xs text-accent mt-1">Clique para mais informações →</p>
        )}
      </div>
    </div>
  );
};
